import { useFetchPublicApi } from '~/composables/fetch/fetchComposables'
import { contentServiceURL } from './apiDomain'

export default {
  getTravelGuide(query: any) {
    return useFetchPublicApi.get(`${contentServiceURL}/destinations/travel-guide`, query, {
      baseURL: process.server ? useRuntimeConfig().localProductContentUrl : useAppConfig().baseApiUrl
    })
  },
}
